<template>
  <div class="basicPortContent">
    <Breadcrumb :matched="matched" />
    <el-tabs v-model="activeName">
      <el-tab-pane
        :label="`船公司${carrierCount ? '(' + carrierCount + ')' : ''}`"
        name="CarrierQuery"
      >
        <CarrierQuery />
      </el-tab-pane>
      <el-tab-pane
        :label="`港区${portCount ? '(' + portCount + ')' : ''}`"
        name="PortQuery"
      >
        <PortQuery />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue'
import CarrierQuery from './CarrierQuery'
import PortQuery from './PortQuery'

const seelp = millis => {
  return new Promise(resolve => {
    setTimeout(resolve, millis)
  })
}

export default {
  name: 'TraceOps',

  components: {
    Breadcrumb,
    CarrierQuery,
    PortQuery,
  },

  data() {
    return {
      activeName: 'CarrierQuery',
      matched: [],

      carrierCount: 0,
      portCount: 0,
    }
  },

  activated() {
    this.$emit('startQueryCount')
  },

  deactivated() {
    this.$emit('pauseQueryCount')
  },

  async mounted() {
    this.matched = this.$route.matched
    let isQueryCount = 1
    this.$on('startQueryCount', () => (isQueryCount = 1))
    this.$on('pauseQueryCount', () => (isQueryCount = 2))
    this.$on('destroyQueryCount', () => (isQueryCount = 0))

    while (isQueryCount > 0) {
      if (isQueryCount === 1) {
        await this.queryCount()
        await seelp(1000 * 60 * 3)
      }
    }
  },

  destroyed() {
    this.$bus.off('clickMenu')
    this.$emit('destroyQueryCount')
  },

  methods: {
    async queryPortCount() {
      try {
        const resp = await this.$axios.get(
          `${this.commonJs.localUrl}/schedules/traceOps/queryPortCount`,
          {
            headers: {
              authorization: `Bearer ${this.getAuthorization()}`,
            },
          }
        )

        if (resp.data.status === 1) {
          return resp.data.content
        }
      } catch (e) {
        console.error(e)
      }
    },

    async queryCarrierCount() {
      try {
        const resp = await this.$axios.get(
          `${this.commonJs.localUrl}/schedules/traceOps/queryCarrierCount`,
          {
            headers: {
              authorization: `Bearer ${this.getAuthorization()}`,
            },
          }
        )

        if (resp.data.status === 1) {
          return resp.data.content
        }
      } catch (e) {
        console.error(e)
      }
    },

    async queryCount() {
      const [carrierCount, portCount] = await Promise.all([
        this.queryCarrierCount(),
        this.queryPortCount(),
      ])
      if (typeof carrierCount === 'number') {
        this.carrierCount = carrierCount
      }
      if (typeof portCount === 'number') {
        this.portCount = portCount
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.basicPortContent {
  padding: 20px 20px 0 20px;

  .el-tabs {
    background-color: #fff;
    padding: 10px 0 20px 0;
  }

  ::v-deep .el-tabs__item.is-active {
    color: #333;
    font-weight: bold;
  }

  ::v-deep .el-tabs__item:hover {
    color: #333;
  }

  ::v-deep .el-tabs__item {
    font-size: 13px;
  }

  ::v-deep .el-tabs__nav-scroll {
    padding-left: 20px;
  }
}
</style>
